import axios from "axios";
import { ILogin } from "../types/ILogin";
import { url } from "./utils/url";
import qs from "qs";

const lang = JSON.parse(localStorage.getItem("lang") as any);

class LoginApi {
  static async Login(body: ILogin) {
    const result = await axios.post(
      `${url}/admin/users/oauth/token`,
      qs.stringify(body),
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "content-language": lang,
        },
      }
    );
    return result.data;
  }

  static async ResetEmail(body: { email: string }) {
    const result = await axios.post(`${url}/users/reset-password`, body, {
      headers: {
        "content-language": lang,
      },
    });
    return result.data;
  }

  static async SendOTP(body: { otp: string }) {
    const result = await axios.post(`${url}/users/verify-otp`, body, {
      headers: {
        "content-language": lang,
      },
    });
    return result.data.user;
  }

  static async ChangePassword(body: {
    password: string;
    confirmPassword: string;
    user_id: string;
  }) {
    const result = await axios.post(`${url}/users/update-password`, body, {
      headers: {
        "content-language": lang,
      },
    });
    return result.data;
  }
}

export default LoginApi;
